import React from "react";
import ActionButton from "./ActionButton";
import { FaSignOutAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { resetApp } from "../../store/actions";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { storageKeys } from "../../constants/storageKeys";

const LogoutButton = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function reset() {
    dispatch(resetApp());
    sessionStorage.clear();
    console.clear();
  }

  const handleClick = () => {
    reset();
    Cookies.remove('apiKey', { 
      path: '/pubserv/BPMN-Chatbot-Beta',
    });
    Cookies.remove('sessionKey', { 
      path: '/pubserv/BPMN-Chatbot-Beta',
    });
    localStorage.removeItem(storageKeys.SESSION_ID); 
    navigate('/enterapikey');
  };

  return (
    <ActionButton
      icon={FaSignOutAlt}
      tooltip="Logout"
      onClick={handleClick}
      variant="dropdown"
    />
  );
};

export default LogoutButton;
